import { GenericServiceBase } from '@/services/generic-service';

/** Por que um item está no painel ao vivo (espelho do server). */
export type MotivoAoVivo = 'EM_ANDAMENTO' | 'RECENTE' | 'AGUARDANDO_ROTEAMENTO' | 'OPERADOR';

export interface EtapaAoVivo {
    etapa: string;
    status: 'INICIADA' | 'SUCESSO' | 'FALHA';
    criadoEm: string;
    duracaoMs?: number | null;
    httpStatus?: number | null;
    erroMensagem?: string | null;
    erroCode?: number | null;
}

export interface WameAoVivo {
    situacao: string;
    origemNumero: string;
    origemNumeroFonte?: string;
    modeloConta?: string;
    roteamentoNecessario: boolean;
    primeiraMensagemEm: string | null;
    roteamentoConfirmadoEm: string | null;
    fundingPresente?: boolean | null;
}

/** Item completo (admin). */
export interface ItemAoVivo {
    idExecucao: string;
    fluxo: string;
    origem: string;
    status: string;
    desfecho: string | null;
    desfechoResumo: string | null;
    etapaDecisiva: string | null;
    idInbox: string | null;
    nomeInbox: string | null;
    idConta: string | null;
    nomeConta: string | null;
    idUsuario: string | null;
    nomeUsuario: string | null;
    numero: string | null;
    phoneNumberId: string | null;
    wabaId: string | null;
    iniciadoEm: string;
    ultimaAtividadeEm: string;
    encerradoEm: string | null;
    totalEtapas: number;
    totalFalhas: number;
    anomalias: string[];
    /** Mais recente primeiro. */
    etapas: EtapaAoVivo[];
    wame: WameAoVivo | null;
    operador?: { idSessao: string; situacao: string; expiraEm: string; operadorNome: string | null; tipo: string } | null;
    motivos: MotivoAoVivo[];
}

/** Recorte do cliente (sem detalhe técnico). */
export interface ItemAoVivoCliente {
    idExecucao: string;
    fluxo: string;
    status: string;
    desfecho: string | null;
    idInbox: string | null;
    nomeInbox: string | null;
    iniciadoEm: string;
    ultimaAtividadeEm: string;
    encerradoEm: string | null;
    etapas: { etapa: string; status: string; criadoEm: string }[];
    wame: Pick<WameAoVivo, 'situacao' | 'origemNumero' | 'roteamentoNecessario' | 'primeiraMensagemEm' | 'roteamentoConfirmadoEm'> | null;
    acompanhamento?: { expiraEm: string; situacao: string } | null;
}

/** Admin: retrato + URL do SSE. */
export class MetaOnboardingAoVivoAdminService extends GenericServiceBase {
    constructor() { super('admin/meta-trilha/onboarding/ao-vivo') }

    async snapshot(): Promise<ItemAoVivo[]> {
        return await this.f.get('') as ItemAoVivo[];
    }

    urlStream(): string {
        return `${String(window.configs.SERVER_URL_PROD).replace(/\/+$/, '')}/admin/meta-trilha/onboarding/ao-vivo/stream`;
    }
}

/** Cliente: retrato das conexões dele (as atualizações chegam pelo socket). */
export class MetaOnboardingAoVivoClienteService extends GenericServiceBase {
    constructor() { super('meta-onboarding/ao-vivo') }

    async listar(): Promise<ItemAoVivoCliente[]> {
        return await this.f.get('') as ItemAoVivoCliente[];
    }
}

/** Ordem do widget: o que exige atenção primeiro. */
export function pesoDoItem(i: { status: string; wame?: { situacao: string } | null; motivos?: MotivoAoVivo[] }): number {
    if (i.motivos?.includes('OPERADOR')) return 0;
    if (i.status === 'EM_ANDAMENTO') return 1;
    if (i.status === 'FALHOU') return 2;
    if (i.wame?.situacao === 'AGUARDANDO_ROTEAMENTO') return 3;
    return 4;
}
